define("post/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f

  var _default = (0, _routes.default)(function () {
    this.route('new', {
      path: '/:media_id/new'
    }, function () {
      this.mount('editor');
    });
    this.route('edit', {
      path: '/:id'
    }, function () {
      this.mount('editor');
    });
    this.route('multi', {
      path: '/:media_id/multi/new'
    }, function () {
      this.mount('editor');
    });
  });

  _exports.default = _default;
});